const validate = values => {
	const errors = {};
	console.log(values)
	if (!values.name) {
		errors.name = 'Este Campo es Obligatorio';
	}
	if (!values.cuil) {
		errors.cuil = 'Este Campo es Obligatorio';
	}
	if (values.cuil &&
		(!/(\d{11})$/.test(values.cuil) || !/(2\d{10})$/.test(values.cuil))) {
		errors.cuil = 'El cuit/cuil no es válido'
	}

	return errors;
};

export default validate;


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsCompanyRepresentativeForm.js
 **/